import { axiosInstance } from "../../config/axios";
import { AxiosError } from "axios";
import { useMutation } from "react-query";
import { BaseResponse } from "../_types";

type GetUnPaidPaymentTotalResponse = BaseResponse<Array<any>>;

async function getUnPaidPaymentTotal(): Promise<GetUnPaidPaymentTotalResponse> {
  try {
    return (
      await axiosInstance.get(`/Dashboard/UnPaidPaymentTotal`)
    ).data;
  } catch (ex) {
    throw ((ex as AxiosError).response?.data as any).error;
  }
}

export function useGetUnPaidPaymentTotal() {
  return useMutation<
    GetUnPaidPaymentTotalResponse,
    Error
  >(() => getUnPaidPaymentTotal());
}
